goog.provide("shadow.js.shim.module$ol$geom$Point$default");
shadow.js.shim.module$ol$geom$Point$default = shadow.js.require(148, {}).default;
